import { useQuery } from '@apollo/client';
import ReactHTMLParser from 'react-html-parser';
import { GET_PAGE_BY_SLUG } from '../../http/apollo-queries';
import { Loading } from '../../components/UI';
import { useNavigate } from 'react-router';

const StaticPage = ({ slug }: { slug: string }) => {
  const navigate = useNavigate();

  const {
    loading,
    error,
    data: { getPageBySlug: page = {} } = {},
  } = useQuery(GET_PAGE_BY_SLUG, {
    variables: {
      slug,
    },
  });

  if (error) {
    navigate('/404');
  }

  const css = `
    p {
      padding: 1rem 0;
    }

    li {
      padding: 0.5rem 0;
    }
  `;

  return (
    <div className="flex justify-center w-full h-full bg-white text-black pb-4 px-4 overflow-auto">
      <div className="flex flex-col items-center max-w-184 mt-14">
        <style>{css}</style>
        <Loading status={loading} />
        {page && (
          <>
            <h1 className="text-2xl font-semibold mb-11">{page.title}</h1>
            {page.content && ReactHTMLParser(page.content)}
          </>
        )}
      </div>
    </div>
  );
};

export default StaticPage;
